import React, { useContext } from "react";
import { SolutionsContext } from "../../App";
import SolutionCard from "./SolutionCard";

function SolutionSecond() {
  const solutionsList = useContext(SolutionsContext);
  return (
    <div className="w-full gap-y-10 flex flex-col justify-center items-center py-10">
      <div className="w-full py-5 md:py-20 flex justify-center items-center text-3xl md:text-7xl font-semibold hover:bg-black hover:bg-opacity-20 rounded-lg bg-slate-300 bg-opacity-50 text-black hover:text-slate-100">
        Web & App Development
      </div>
      {solutionsList.map((solution) => {
        return (
          <div key={solution.id} className="text-3xl md:text-6xl w-11/12 text-slate-100">
            <h2 className="text-[#00B3E1]">{solution.title}</h2>
            <h3 className="text-2xl md:text-4xl pt-3 text-slate-100">
              {solution.titleQuote}
            </h3>
            <div className="w-full py-10 px-10 flex justify-center">
              <SolutionCard cardDetails={solution.cardDetails} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SolutionSecond;
